//用户系统(本地8092)
import VUE_APP_API_DORIS_URL from '../src/api/getapi/doris'
import axios from "axios";


let apiURLUser = ''
if (process.env.NODE_ENV === "development") {
    apiURLUser = 'http://proxy.jiankanghao.net:50242/api/v1/'
} else {
    apiURLUser = VUE_APP_API_DORIS_URL
}


const exportApi = axios.create({
    baseURL: apiURLUser,
})
// http response 拦截器
exportApi.interceptors.response.use(
    response => {
        console.log(response, "拦截器");
        if (response.status == 200) {
            return response
        }
    },
    error => {
        return Promise.reject(error.response) // 返回接口返回的错误信息
    });

export {
    exportApi
}

